import { useStyles } from "./Page.styles";
import type { PageProps } from "./types";

/**
 * This is a custom MyEROAD component. `<Page>` is expected to be used to create the top level element for most routes in MyEROAD. <p>
 * The standard page container. It is relative positioned and handles overflow correctly including in iframe (when using `PageContent`). <p>
 * Page components include `Page`, `PageHeader`, `PageBreadcrumb`, `PageTitle`, `PageSubtitle`, `PageDescription`, `PageInfoItem`, `PageInfoWrapper`, `PageContent`, `PageFooter`, `PageSpinner`, and `PageError`.
 * Use these components to produce a standard page layout. These should be used for all routes unless it's obvious otherwise.
 */
const Page = ({ children, ...props }: PageProps) => {
  const classes = useStyles();

  return (
    <div data-pendoid={props["data-pendoid"]} className={classes.root}>
      {children}
    </div>
  );
};

export { Page };
